import AdminLayout from "@/layouts/AdminLayout";
import AkademikLayout from "@/layouts/AkademikLayout";
import GuestLayout from "@/layouts/GuestLayout";
import LoketmanLayout from "@/layouts/LoketmanLayout";
import OperatorInternasionalLayout from "@/layouts/OperatorInternasionalLayout";
import OperatorPascaLayout from "@/layouts/OperatorPascaLayout";
import OperatorStudentExchangeLayout from "@/layouts/OperatorStudentExchangeLayout";
import PanitiaSmbjmLayout from "@/layouts/PanitiaSmbjmLayout";
import PimpinanLayout from "@/layouts/PimpinanLayout";
import SiswaLayout from "@/layouts/SiswaLayout";
import VerifikatorButawarnaLayout from "@/layouts/VerifikatorButawarnaLayout";
import VerifikatorLayout from "@/layouts/VerifikatorLayout";
import VerifikatorPascaLayout from "@/layouts/VerifikatorPascaLayout";
import VerifikatorKepemimpinanLayout from "@/layouts/VerifikatorKepemimpinanLayout";
import VerifikatorRaportLayout from "@/layouts/VerifikatorRaportLayout";
import VerifikatorSehatLayout from "@/layouts/VerifikatorSehatLayout";
import VerifikatorSklLayout from "@/layouts/VerifikatorSklLayout";
import WawancaraTalentscoutingLayout from "@/layouts/WawancaraTalentscoutingLayout";
import {
  setGlobalColorTheme,
  setSecondaryTheme,
  setSidebarTheme,
} from "@/lib/utils";
import StepPenerimaanPascaMiddleware from "@/middlewares/StepPenerimaanPascaMiddleware";
import SystemMaintenanceMiddleware from "@/middlewares/SystemMaintenanceMiddleware";
import DetailNilaiRaportSmbjmPublicPage from "@/pages/DetailNilaiRaportSmbjmPublicPage";
import DetailNilaiKepemimpinanSmbjmPublicPage from "@/pages/DetailNilaiKepemimpinanSmbjmPublicPage";
import DetailNilaiTalentPublicPage from "@/pages/DetailNilaiTalent";
import GlobalDashboardPage from "@/pages/GlobalDashboardPage";
import RedirectSpmbLab from "@/pages/RedirectSpmbLab";
import RedirectSpmbLabAdmin from "@/pages/RedirectSpmbLabAdmin";
import DashboardPage from "@/pages/admin/dashboard/DashboardPage";
import DataPendaftaranPage from "@/pages/admin/data-pendaftaran/DataPendaftaranPage";
import DataPrestasiPage from "@/pages/admin/data-prestasi/DataPrestasiPage";
import DataSiswaPage from "@/pages/admin/data-siswa/DataSiswaPage";
import DataUktPendaftarLulus from "@/pages/admin/data-ukt-pendaftar-lulus/DataUktPendaftarLulus";
import MasterAgamaPage from "@/pages/admin/master/agama/MasterAgamaPage";
import MasterAlatTransportasiPage from "@/pages/admin/master/alat-transportasi/MasterAlatTransportasi";
import MasterCapaianPrestasiPage from "@/pages/admin/master/capaian-prestasi/MasterCapaianPrestasiPage";
import MasterDaftarProgramPage from "@/pages/admin/master/daftar-program/MasterDaftarProgramPage";
import MasterGrupPrestasiPage from "@/pages/admin/master/grup-prestasi/MasterGrupPrestasi";
import MasterHubunganKeluargaPage from "@/pages/admin/master/hubungan-keluarga/MasterHubunganKeluargaPage.tsx";
import MasterJalurFeederPage from "@/pages/admin/master/jalur-feeder/MasterJalurFeederPage";
import MasterJenisDaftarFeederPage from "@/pages/admin/master/jalur-feeder/jenis-daftar-feeder/MasterJenisDaftarFeederPage";
import MasterJalurGroupPage from "@/pages/admin/master/jalur-group/MasterJalurGroupPage";
import MasterJalurJenisPage from "@/pages/admin/master/jalur-jenis/MasterJalurJenisPage";
import MasterJalurPage from "@/pages/admin/master/jalur/MasterJalurPage";
import MasterJenisAsetPage from "@/pages/admin/master/jenis-aset/MasterJenisAsetPage";
import MasterJenisBerkasPage from "@/pages/admin/master/jenis-berkas/MasterJenisBerkasPage";
import MasterJenisBiayaPage from "@/pages/admin/master/jenis-biaya/MasterJenisBiayaPage";
import MasterJenisPrestasiPage from "@/pages/admin/master/jenis-prestasi/MasterJenisPrestasiPage";
import MasterJenisTinggal from "@/pages/admin/master/jenis-tinggal/MasterJenisTinggalPage";
import MasterJenisUktPage from "@/pages/admin/master/jenis-ukt/MasterJenisUkt";
import MasterJenjangPendidikanPage from "@/pages/admin/master/jenjang-pendidikan/MasterJenjangPendidikanPage";
import MasterJenjangPrestasiPage from "@/pages/admin/master/jenjang-prestasi/MasterJenjangPrestasiPage";
import MasterJumlahTanggunganPage from "@/pages/admin/master/jumlah-tanggungan/MasterJumlahTanggunganPage";
import MasterJurusanSekolahPage from "@/pages/admin/master/jurusan-sekolah/MasterJurusanSekolahPage";
import MasterKebutuhanKhusus from "@/pages/admin/master/kebutuhan-khusus/MasterKebutuhanKhususPage";
import MasterKepemilikanAssetPage from "@/pages/admin/master/kepemilikan-asset/MasterKepemilikanAssetPage";
import MasterKonsentrasiProdiPage from "@/pages/admin/master/konsentrasi-prodi/KonsentrasiProdiPage";
import MasterLayananPlazaPage from "@/pages/admin/master/layanan-plaza/MasterLayananPlazaPage";
import MasterSubLayanan1PlazaPage from "@/pages/admin/master/layanan-plaza/sub-layanan-1/MasterSubLayanan1PlazaPage";
import MasterSubLayanan2PlazaPage from "@/pages/admin/master/layanan-plaza/sub-layanan-2/MasterSubLayanan2PlazaPage";
import MasterSubStatusPlazaPage from "@/pages/admin/master/layanan-plaza/sub-status-plaza/MasterSubStatusPlazaPage.tsx";
import MasterLayananSmartPaymentPage from "@/pages/admin/master/layanan-smart-payment/MasterLayananSmartPayment";
import MasterLevelWilayahPage from "@/pages/admin/master/level-wilayah/MasterLevelWilayahPage";
import MasterLuasAsetPage from "@/pages/admin/master/luas-aset/LuasAsetPage";
import MasterNegaraPage from "@/pages/admin/master/negara/MasterNegaraPage";
import MasterNominalUktPage from "@/pages/admin/master/nominal-ukt/MasterNominalUktPage";
import MasterPangkatGolonganPage from "@/pages/admin/master/pangkat-golongan/MasterPangkatGolonganPage";
import MasterPekerjaanPage from "@/pages/admin/master/pekerjaan/MasterPekerjaanPage";
import MasterPembayaranAirAsetPage from "@/pages/admin/master/pembayaran-air-aset/PembayaranAirAsetPage";
import MasterPenghasilanPage from "@/pages/admin/master/penghasilan/MasterPenghasilanPage";
import MasterPerguruanTinggiProdiPage from "@/pages/admin/master/perguruan-tinggi-prodi/MasterPerguruanTinggiProdiPage";
import MasterPerguruanTinggiPage from "@/pages/admin/master/perguruan-tinggi/MasterPerguruanTinggiPage";
import MasterSdmPage from "@/pages/admin/master/sdm/MasterSdmPage";
import MasterSekolahPage from "@/pages/admin/master/sekolah/MasterSekolahPage";
import MasterSpkPage from "@/pages/admin/master/spk/MasterSpkPage";
import MasterSumberAirPage from "@/pages/admin/master/sumber-air/SumberAirPage";
import MasterSumberListrikPage from "@/pages/admin/master/sumber-listrik/SumberListrikPage";
import MasterTeganganListrikAsetPage from "@/pages/admin/master/tegangan-listrik-aset/TeganganListrikAsetPage";
import MasterUnitkerjaGroupPage from "@/pages/admin/master/unitkerja-group/MasterUnitkerjaGroupPage";
import MasterUnitkerjaPage from "@/pages/admin/master/unitkerja/MasterUnitkerjaPage";
import MasterUserPage from "@/pages/admin/master/user/MasterUserPage";
import MasterWilayahPage from "@/pages/admin/master/wilayah/MasterWilayahPage";
import MasterWilayahMergePage from "@/pages/admin/master/wilayah/merge/MasterWilayahMerge";
import SertifikatCbtPage from "@/pages/admin/sertifikat-cbt/SertifikatCbtPage";
import SettingBerkasPortofolio from "@/pages/admin/setting/berkas-portofolio/SettingBerkasPortofolio";
import SettingMaintenancePage from "@/pages/admin/setting/maintenance/SettingMaintenancePage";
import SettingPeriodePage from "@/pages/admin/setting/periode/SettingPeriodePage";
import SettingPeriodeDetailPage from "@/pages/admin/setting/periode/detail/SettingPeriodeDetailPage";
import SettingRuangCbtPage from "@/pages/admin/setting/ruang-cbt/SettingRuangCbtPage";
import SettingRuangCbtDetailPage from "@/pages/admin/setting/ruang-cbt/detail/SettingRuangCbtDetailPage";
import SettingTahapanCbtPage from "@/pages/admin/setting/ruang-cbt/tahapan/SettingTahapanCbtPage";
import SettingSystemPage from "@/pages/admin/setting/system/SettingSystemPage";
import SettingVerifikatorButawarnaPage from "@/pages/admin/setting/verifikator/butawarna/SettingVerifikatorButawarnaPage";
import SettingVerifikatorButawarnaDetailPage from "@/pages/admin/setting/verifikator/butawarna/detail/SettingVerifikatorButawarnaDetailPage";
import SettingVerifikatorKepemimpinanPage from "@/pages/admin/setting/verifikator/kepemimpinan/SettingVerifikatorKepemimpinanPage";
import SettingVerifikatorKepemimpinanDetailPage from "@/pages/admin/setting/verifikator/kepemimpinan/detail/SettingVerifikatorKepemimpinanDetailPage";
import SettingVerifikatorRaportPage from "@/pages/admin/setting/verifikator/raport/SettingVerifikatorRaportPage";
import SettingVerifikatorRaportDetailPage from "@/pages/admin/setting/verifikator/raport/detail/SettingVerifikatorRaportDetailPage";
import SettingVerifikatorSklPage from "@/pages/admin/setting/verifikator/skl/SettingVerifikatorSklPage";
import SettingVerifikatorSklDetailPage from "@/pages/admin/setting/verifikator/skl/detail/SettingVerifikatorSklDetailPage";
import SettingVerifikatorSuratKeteranganSehatPage from "@/pages/admin/setting/verifikator/surat-keterangan-sehat/SettingVerifikatorSuratKeteranganSehatPage";
import SettingVerifikatorSuratKeteranganSehatDetailPage from "@/pages/admin/setting/verifikator/surat-keterangan-sehat/detail/SettingVerifikatorSuratKeteranganSehatDetailPage";
import SettingVerifikatorPage from "@/pages/admin/setting/verifikator/ukt/SettingVerifikatorPage";
import SettingVerifikatorDetailPage from "@/pages/admin/setting/verifikator/ukt/detail/SettingVerifikatorDetailPage";
import SyncDataPembayaranUktPage from "@/pages/admin/sync/data-pembayaran-ukt/SyncDataPembayaranUkt";
import SyncMataPelajaranPage from "@/pages/admin/sync/mata-pelajaran/SyncMataPelajaranPage";
import SyncNilaiCbtPage from "@/pages/admin/sync/nilai-cbt/SyncNilaiCbtPage";
import SyncNilaiRaporPage from "@/pages/admin/sync/nilai-rapor/SyncNilaiRaporPage";
import DashboardAkademikPage from "@/pages/akademik/dashboard/DashboardAkademikPage";
import DataPendaftaranAkademikPage from "@/pages/akademik/data-pendaftaran/DataPendaftaranPage";
import ForgotPasswordPage from "@/pages/auth/forgot-password/ForgotPasswordPage";
import ForgotPasswordResetPage from "@/pages/auth/forgot-password/reset/ForgotPasswordResetPage";
import LoginPage from "@/pages/auth/login/LoginPage";
import ProfilePage from "@/pages/auth/profile/ProfilePage";
import RegistrasiPage from "@/pages/auth/regsitrasi/RegistrasiPage";
import ResetPasswordPage from "@/pages/auth/reset-password/ResetPasswordPage";
import ErrorPage from "@/pages/error/ErrorPage";
import NotFoundPage from "@/pages/error/NotFoundPage";
import InternationalAdmissionPage from "@/pages/landing/InternationalAdmissionPage";
import LandingPage from "@/pages/landing/LandingPage";
import StudentExchangePage from "@/pages/landing/StudentExchangePage";
import InformasiJalur from "@/pages/landing/detail/InformasiJalur";
import LoketmanPage from "@/pages/loketman/LoketmanPage";
import DashboardOperatorInternasionalPage from "@/pages/operator-internasional/dashboard/DashboardOperatorInternasionalPage";
import DataPendaftaranInternasionalPage from "@/pages/operator-internasional/data-pendaftaran/DataPendaftaranInternasionalPage";
import DashboardOperatorPascaPage from "@/pages/operator-pasca/dashboard/DashboardOperatorPascaPage";
import DataLoaPage from "@/pages/operator-pasca/data-loa/DataLoaPage";
import DataNilaiPage from "@/pages/operator-pasca/data-nilai/DataNilaiPage";
import DataPendaftaranPascaPage from "@/pages/operator-pasca/data-pendaftaran/DataPendaftaranPascaPage";
import GroupsElearningPage from "@/pages/operator-pasca/groups-elearning/GroupsElearningPage";
import MasterBobotKomponenKaryatulisPage from "@/pages/operator-pasca/master/bobot-komponen-karyatulis/MasterBobotKomponenKaryatulisPage";
import MasterBobotKomponenPenilaianPage from "@/pages/operator-pasca/master/bobot-komponen-penilaian/MasterBobotKomponenPenilaianPage";
import MasterKomponenPenilaianPage from "@/pages/operator-pasca/master/komponen-penilaian/MasterKomponenPenilaianPage";
import MasterParentKomponenPenilaianPage from "@/pages/operator-pasca/master/parent-komponen-penilaian/MasterParentKomponenPenilaianPage";
import NilaiElearningPage from "@/pages/operator-pasca/nilai-elearning/NilaiElearningPage";
import SettingVerifikatorPascaPage from "@/pages/operator-pasca/setting/verifikator/SettingVerifikatorPascaPage";
import SettingVerifikatorPascaDetailPage from "@/pages/operator-pasca/setting/verifikator/detail/SettingVerifikatorPascaDetailPage";
import UsersElearningPage from "@/pages/operator-pasca/users-elearning/UsersElearningPage";
import DataPendaftaranStudentExchangePage from "@/pages/operator-studentexchange/data-pendaftaran/DataPendaftaranStudentExchangePage";
import SettingPeriodeOperatorStudentExchangePage from "@/pages/operator-studentexchange/setting/periode/SettingPeriodeOperatorStudentExchangePage";
import PanitiaSmbjmPage from "@/pages/panitia-smbjm/PanitiaSmbjmPage";
import AlbumPesertaPage from "@/pages/panitia-smbjm/album-peserta/AlbumPesertaPage";
import RuangCbtDetailPage from "@/pages/panitia-smbjm/ruang-cbt-detail/RuangCbtDetailPage";
import DashboardPimpinanPage from "@/pages/pimpinan/dashboard/DashboardPimpinanPage";
import DaftarKembaliPage from "@/pages/siswa/daftar-kembali/DaftarKembaliPage";
import DashboardSiswaPage from "@/pages/siswa/dashboard/DashboardSiswaPage";
import PenerimaanCbtPage from "@/pages/siswa/penerimaan/cbt/PenerimaanCbtPage";
import PenerimaanInternasionalPage from "@/pages/siswa/penerimaan/internasional/PenerimaanInternasionalPage";
import PenerimaanKepemimpinan from "@/pages/siswa/penerimaan/kepemimpinan/PenerimaanKepemimpinan";
import PenerimaanPascasarjanaPage from "@/pages/siswa/penerimaan/pascasarjana/PenerimaanPascasarjanaPage";
import PenerimaanPrestasiPage from "@/pages/siswa/penerimaan/prestasi/PenerimaanPrestasiPage";
import PenerimaanProfesiPage from "@/pages/siswa/penerimaan/profesi/PenerimaanProfesiPage";
import PenerimaanFasttrackPage from "@/pages/siswa/penerimaan/fasttrack/PenerimaanFasttrackPage";
import PenerimaanRplPage from "@/pages/siswa/penerimaan/rpl/PenerimaanRplPage";
import PenerimaanSekolahLab from "@/pages/siswa/penerimaan/sekolahlab/PenerimaanSekolahLab";
import PenerimaanSkorUTBK from "@/pages/siswa/penerimaan/skorutbk/PenerimaanSkorUTBK";
import CheckStatusUtbkPage from "@/pages/siswa/penerimaan/smbjm/skor-utbk/CheckStatusUtbkPage";
import PenerimaanStudentExchange from "@/pages/siswa/penerimaan/studentexchange/PenerimaanStudentExchange";
import PenerimaanTalentScoutingPage from "@/pages/siswa/penerimaan/talentscouting/PenerimaanTalentScoutingPage";
import PengumumanKelulusanPage from "@/pages/siswa/pengumuman-kelulusan/PengumumanKelulusanPage";
import PengumumanPage from "@/pages/siswa/pengumuman/PengumumanPage";
import DashboardSiswaRplPage from "@/pages/siswa/rpl/dashboard/DashboardSiswaRplPage";
import TestOrcPage from "@/pages/test/TestOrcPage";
import VerifikatorPascaDataNilaiPage from "@/pages/verifikator-pasca/data-nilai/VerifikatorPascaDataNilaiPage";
import VerifikatorPascaPenilaianPage from "@/pages/verifikator-pasca/penilaian/VerifikatorPascaPenilaianPage";
import DashboardVerifikatorButawarnaPage from "@/pages/verifikator/butawarna/dashboard/DashboardVerifikatorButawarnaPage";
import VerifikasiPesertaButawarnaPage from "@/pages/verifikator/butawarna/verifikasi-peserta-butawarna/VerifikasiPesertaButawarnaPage";
import VerifikasiPesertaButawarnaDetailPage from "@/pages/verifikator/butawarna/verifikasi-peserta-butawarna/detail/VerifikasiPesertaButawarnaDetailPage";
import DashboardVerifikatorRaportPage from "@/pages/verifikator/raport/dashboard/DashboardVerifikatorRaportPage";
import VerifikatorPesertaKepemimpinanSmbjmPage from "@/pages/verifikator/kepemimpinan/peserta-kepemimpinan-smbjm/VerifikatorPesertaKepemimpinanSmbjmPage";
import VerifikatorDataNilaiRaportSmbjmPage from "@/pages/verifikator/raport/data-nilai-raport-smbjm/VerifikatorDataNilaiRaportSmbjmPage";
import VerifikasiRaportPesertaPage from "@/pages/verifikator/raport/verifikasi-raport/VerifikasiRaportPesertaPage";
import VerifikasiRaportPesertaDetailPage from "@/pages/verifikator/raport/verifikasi-raport/detail/VerifikasiRaportPesertaDetailPage";
import DashboardVerifikatorSklPage from "@/pages/verifikator/skl/dashboard/DashboardVerifikatorSklPage";
import VerifikasiSklPesertaPage from "@/pages/verifikator/skl/verifikasi-skl/VerifikasiSklPesertaPage";
import VerifikasiSklDetailPage from "@/pages/verifikator/skl/verifikasi-skl/detail/VerifikasiSklDetailPage";
import DashboardVerifikatorSehatPage from "@/pages/verifikator/surat-keterangan-sehat/dashboard/DashboardVerifikatorSehatPage";
import VerifikasiPesertaSehatPage from "@/pages/verifikator/surat-keterangan-sehat/verifikasi-peserta-surat-keterangan-sehat/VerifikasiPesertaSehatPage";
import VerifikasiPesertaSehatDetailPage from "@/pages/verifikator/surat-keterangan-sehat/verifikasi-peserta-surat-keterangan-sehat/detail/VerifikasiPesertaSehatDetailPage";
import DashboardVerifikatorPage from "@/pages/verifikator/ukt/dashboard/DashboardVerifikatorPage";
import RekapVerifikasiPage from "@/pages/verifikator/ukt/rekap/RekapVerifikasiPage";
import VerifikasiBerkasPage from "@/pages/verifikator/ukt/verifikasi-berkas/VerifikasiBerkasPage";
import VerifikasiBerkasDetailPage from "@/pages/verifikator/ukt/verifikasi-berkas/detail/VerifikasiBerkasDetailPage";
import DataPendaftaranPesertaTalentscoutingPage from "@/pages/wawancara-talentscouting/data-pendaftaran/DataPendaftaranPesertaTalentscoutingPage";
import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const { location } = window;
const isHttps = location.origin.startsWith("https");

const router = createBrowserRouter([
  {
    path: "/test-ocr",
    element: <TestOrcPage />,
  },
  {
    path: "/view/nilai-raport-smbjm",
    element: <DetailNilaiRaportSmbjmPublicPage />,
  },
  {
    path: "/view/nilai-kepemimpinan-smbjm",
    element: <DetailNilaiKepemimpinanSmbjmPublicPage />,
  },
  {
    path: "/view/nilai-talent",
    element: <DetailNilaiTalentPublicPage />,
  },
  {
    path: "/spmb-sekolah-lab/admin",
    element: <RedirectSpmbLabAdmin />,
  },
  {
    path: "/spmb-sekolah-lab",
    element: <RedirectSpmbLab />,
  },
  {
    path: "/international-admission",
    element: <InternationalAdmissionPage />,
  },
  {
    path: "/student-exchange",
    element: <StudentExchangePage />,
  },
  {
    path: "/",
    element: <LandingPage />,
    errorElement: isHttps && <ErrorPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
    errorElement: isHttps && <ErrorPage />,
  },
  {
    path: "/forgot-password/reset",
    element: <ForgotPasswordResetPage />,
    errorElement: isHttps && <ErrorPage />,
  },
  {
    path: "/informasi-jalur",
    element: <InformasiJalur />,
  },
  {
    element: <SystemMaintenanceMiddleware />,
    errorElement: isHttps && <ErrorPage />,
    children: [
      {
        element: <SiswaLayout />,
        children: [
          { path: "/dashboard-rpl", element: <DashboardSiswaRplPage /> },
          { path: "/dashboard", element: <DashboardSiswaPage /> },
          {
            path: "/penerimaan/studentexchange",
            element: <PenerimaanStudentExchange />,
          },
          {
            path: "/penerimaan/internasional",
            element: <PenerimaanInternasionalPage />,
          },
          {
            path: "/penerimaan/cbt",
            element: <PenerimaanCbtPage />,
          },
          {
            path: "/penerimaan/talent",
            element: <PenerimaanTalentScoutingPage />,
          },
          {
            path: "/penerimaan/prestasi",
            element: <PenerimaanPrestasiPage />,
          },
          {
            path: "/penerimaan/kepemimpinan",
            element: <PenerimaanKepemimpinan />,
          },
          {
            path: "/penerimaan/sekolahlab",
            element: <PenerimaanSekolahLab />,
          },
          {
            path: "/penerimaan/skorutbk",
            element: <PenerimaanSkorUTBK />,
          },
          {
            path: "/penerimaan/skorutbk/check",
            element: <CheckStatusUtbkPage />,
          },
          {
            element: <StepPenerimaanPascaMiddleware />,
            children: [
              {
                path: "/penerimaan/pascasarjana",
                element: <PenerimaanPascasarjanaPage />,
              },
              {
                path: "/penerimaan/profesi",
                element: <PenerimaanProfesiPage />,
              },
              {
                path: "/penerimaan/fasttrack",
                element: <PenerimaanFasttrackPage />,
              },
              {
                path: "/penerimaan/rpl",
                element: <PenerimaanRplPage />,
              },
            ],
          },
          { path: "/daftar-kembali", element: <DaftarKembaliPage /> },
          { path: "/pengumuman", element: <PengumumanPage /> },
          {
            path: "/pengumuman-kelulusan",
            element: <PengumumanKelulusanPage />,
          },
          { path: "/profile", element: <ProfilePage /> },
          { path: "/reset-password", element: <ResetPasswordPage /> },
        ],
      },
    ],
  },

  {
    element: <SystemMaintenanceMiddleware />,
    children: [
      {
        element: <GuestLayout />,
        children: [{ path: "/registrasi", element: <RegistrasiPage /> }],
      },
    ],
  },
  {
    element: <GuestLayout />,
    children: [{ path: "/login", element: <LoginPage /> }],
  },
  {
    element: <AdminLayout />,
    children: [
      { path: "/admin/dashboard", element: <DashboardPage /> },
      { path: "/admin/data-siswa", element: <DataSiswaPage /> },
      { path: "/admin/data-pendaftaran", element: <DataPendaftaranPage /> },
      { path: "/admin/data-prestasi", element: <DataPrestasiPage /> },
      {
        path: "/admin/data-ukt-pendaftar-lulus",
        element: <DataUktPendaftarLulus />,
      },
      { path: "/admin/master/user", element: <MasterUserPage /> },
      { path: "/admin/master/jalur", element: <MasterJalurPage /> },
      { path: "/admin/master/jalur-group", element: <MasterJalurGroupPage /> },
      { path: "/admin/master/jenis-tinggal", element: <MasterJenisTinggal /> },
      { path: "/admin/master/jalur-jenis", element: <MasterJalurJenisPage /> },
      { path: "/admin/master/jenis-aset", element: <MasterJenisAsetPage /> },
      { path: "/admin/master/luas-aset", element: <MasterLuasAsetPage /> },
      {
        path: "/admin/master/pembayaran-air-aset",
        element: <MasterPembayaranAirAsetPage />,
      },
      {
        path: "/admin/master/tegangan-listrik-aset",
        element: <MasterTeganganListrikAsetPage />,
      },
      {
        path: "/admin/master/hubungan-keluarga",
        element: <MasterHubunganKeluargaPage />,
      },
      { path: "/admin/master/agama", element: <MasterAgamaPage /> },
      {
        path: "/admin/master/alat-transportasi",
        element: <MasterAlatTransportasiPage />,
      },
      { path: "/admin/master/negara", element: <MasterNegaraPage /> },
      {
        path: "/admin/master/level-wilayah",
        element: <MasterLevelWilayahPage />,
      },
      { path: "/admin/master/wilayah", element: <MasterWilayahPage /> },
      {
        path: "/admin/master/wilayah-merge",
        element: <MasterWilayahMergePage />,
      },
      {
        path: "/admin/master/unitkerja-group",
        element: <MasterUnitkerjaGroupPage />,
      },
      { path: "/admin/master/unitkerja", element: <MasterUnitkerjaPage /> },
      {
        path: "/admin/master/konsentrasi-prodi",
        element: <MasterKonsentrasiProdiPage />,
      },
      {
        path: "/admin/master/jenjang-pendidikan",
        element: <MasterJenjangPendidikanPage />,
      },
      {
        path: "/admin/master/kepemilikan-asset",
        element: <MasterKepemilikanAssetPage />,
      },
      {
        path: "/admin/master/jenis-prestasi",
        element: <MasterJenisPrestasiPage />,
      },
      {
        path: "/admin/master/jenjang-prestasi",
        element: <MasterJenjangPrestasiPage />,
      },
      {
        path: "/admin/master/capaian-prestasi",
        element: <MasterCapaianPrestasiPage />,
      },
      {
        path: "/admin/master/grup-prestasi",
        element: <MasterGrupPrestasiPage />,
      },
      {
        path: "/admin/master/pangkat-golongan",
        element: <MasterPangkatGolonganPage />,
      },
      {
        path: "/admin/master/pekerjaan",
        element: <MasterPekerjaanPage />,
      },
      {
        path: "/admin/master/jumlah-tanggungan",
        element: <MasterJumlahTanggunganPage />,
      },
      {
        path: "/admin/master/sumber-air",
        element: <MasterSumberAirPage />,
      },
      {
        path: "/admin/master/sumber-listrik",
        element: <MasterSumberListrikPage />,
      },
      {
        path: "/admin/master/jenis-berkas",
        element: <MasterJenisBerkasPage />,
      },
      { path: "/admin/master/sekolah", element: <MasterSekolahPage /> },
      {
        path: "/admin/master/jurusan-sekolah",
        element: <MasterJurusanSekolahPage />,
      },
      {
        path: "/admin/master/perguruan-tinggi",
        element: <MasterPerguruanTinggiPage />,
      },
      {
        path: "/admin/master/perguruan-tinggi-prodi",
        element: <MasterPerguruanTinggiProdiPage />,
      },
      { path: "/admin/master/penghasilan", element: <MasterPenghasilanPage /> },
      { path: "/admin/master/sdm", element: <MasterSdmPage /> },
      {
        path: "/admin/master/kebutuhan-khusus",
        element: <MasterKebutuhanKhusus />,
      },
      { path: "/admin/master/spk", element: <MasterSpkPage /> },
      { path: "/admin/master/jenis-biaya", element: <MasterJenisBiayaPage /> },
      { path: "/admin/master/jenis-ukt", element: <MasterJenisUktPage /> },
      { path: "/admin/master/nominal-ukt", element: <MasterNominalUktPage /> },
      {
        path: "/admin/master/layanan-smart-payment",
        element: <MasterLayananSmartPaymentPage />,
      },
      {
        path: "/admin/master/layanan-plaza",
        element: <MasterLayananPlazaPage />,
      },
      {
        path: "/admin/master/layanan-plaza/sub-layanan-1",
        element: <MasterSubLayanan1PlazaPage />,
      },
      {
        path: "/admin/master/layanan-plaza/sub-layanan-2",
        element: <MasterSubLayanan2PlazaPage />,
      },
      {
        path: "/admin/master/layanan-plaza/sub-status",
        element: <MasterSubStatusPlazaPage />,
      },
      {
        path: "/admin/master/jalur-feeder",
        element: <MasterJalurFeederPage />,
      },
      {
        path: "/admin/master/jalur-feeder/jenis-daftar-feeder",
        element: <MasterJenisDaftarFeederPage />,
      },
      {
        path: "/admin/master/daftar-program",
        element: <MasterDaftarProgramPage />,
      },
      { path: "/admin/setting/periode", element: <SettingPeriodePage /> },
      {
        path: "/admin/setting/periode/detail",
        element: <SettingPeriodeDetailPage />,
      },
      {
        path: "/admin/setting/berkas-portofolio",
        element: <SettingBerkasPortofolio />,
      },
      {
        path: "/admin/setting/verifikator/ukt",
        element: <SettingVerifikatorPage />,
      },
      {
        path: "/admin/setting/verifikator/ukt/detail",
        element: <SettingVerifikatorDetailPage />,
      },
      {
        path: "/admin/setting/verifikator/butawarna",
        element: <SettingVerifikatorButawarnaPage />,
      },
      {
        path: "/admin/setting/verifikator/butawarna/detail",
        element: <SettingVerifikatorButawarnaDetailPage />,
      },
      {
        path: "/admin/setting/verifikator/surat-keterangan-sehat",
        element: <SettingVerifikatorSuratKeteranganSehatPage />,
      },
      {
        path: "/admin/setting/verifikator/surat-keterangan-sehat/detail",
        element: <SettingVerifikatorSuratKeteranganSehatDetailPage />,
      },
      {
        path: "/admin/setting/verifikator/raport",
        element: <SettingVerifikatorRaportPage />,
      },
      {
        path: "/admin/setting/verifikator/raport/detail",
        element: <SettingVerifikatorRaportDetailPage />,
      },
      {
        path: "/admin/setting/verifikator/skl",
        element: <SettingVerifikatorSklPage />,
      },
      {
        path: "/admin/setting/verifikator/skl/detail",
        element: <SettingVerifikatorSklDetailPage />,
      },
      {
        path: "/admin/setting/verifikator/kepemimpinan",
        element: <SettingVerifikatorKepemimpinanPage />,
      },
      {
        path: "/admin/setting/verifikator/kepemimpinan/detail",
        element: <SettingVerifikatorKepemimpinanDetailPage />,
      },
      {
        path: "/admin/setting/ruang-cbt",
        element: <SettingRuangCbtPage />,
      },
      {
        path: "/admin/setting/ruang-cbt/detail",
        element: <SettingRuangCbtDetailPage />,
      },
      {
        path: "/admin/setting/ruang-cbt/tahapan",
        element: <SettingTahapanCbtPage />,
      },
      {
        path: "/admin/setting/system",
        element: <SettingSystemPage />,
      },
      {
        path: "/admin/setting/maintenance",
        element: <SettingMaintenancePage />,
      },
      {
        path: "/admin/sync/mata-pelajaran",
        element: <SyncMataPelajaranPage />,
      },
      {
        path: "/admin/sync/nilai-rapor",
        element: <SyncNilaiRaporPage />,
      },
      {
        path: "/admin/sync/nilai-cbt",
        element: <SyncNilaiCbtPage />,
      },
      {
        path: "/admin/sync/data-pembayaran-ukt",
        element: <SyncDataPembayaranUktPage />,
      },
      {
        path: "/admin/sertifikat-cbt/index",
        element: <SertifikatCbtPage />,
      },
    ],
  },
  {
    element: <PimpinanLayout />,
    children: [
      { path: "/pimpinan/dashboard", element: <DashboardPimpinanPage /> },
    ],
  },
  {
    element: <VerifikatorLayout />,
    children: [
      {
        path: "/verifikator/dashboard",
        element: <DashboardVerifikatorPage />,
      },
      {
        path: "/verifikator/verifikasi-berkas",
        element: <VerifikasiBerkasPage />,
      },
      {
        path: "/verifikator/verifikasi-berkas/view",
        element: <VerifikasiBerkasDetailPage />,
      },
      {
        path: "/verifikator/rekap-verifikasi",
        element: <RekapVerifikasiPage />,
      },
    ],
  },
  {
    element: <VerifikatorButawarnaLayout />,
    children: [
      {
        path: "/verifikator/butawarna/dashboard",
        element: <DashboardVerifikatorButawarnaPage />,
      },
      {
        path: "/verifikator/butawarna/verifikasi-peserta-butawarna",
        element: <VerifikasiPesertaButawarnaPage />,
      },
      {
        path: "/verifikator/butawarna/verifikasi-peserta-butawarna/view",
        element: <VerifikasiPesertaButawarnaDetailPage />,
      },
    ],
  },
  {
    element: <VerifikatorSehatLayout />,
    children: [
      {
        path: "/verifikator/surat-keterangan-sehat/dashboard",
        element: <DashboardVerifikatorSehatPage />,
      },
      {
        path: "/verifikator/surat-keterangan-sehat/verifikasi-peserta-surat-keterangan-sehat",
        element: <VerifikasiPesertaSehatPage />,
      },
      {
        path: "/verifikator/surat-keterangan-sehat/verifikasi-peserta-surat-keterangan-sehat/view",
        element: <VerifikasiPesertaSehatDetailPage />,
      },
    ],
  },
  {
    element: <VerifikatorKepemimpinanLayout />,
    children: [
      {
        path: "/verifikator/kepemimpinan/verifikasi-peserta-kepemimpinan-smbjm",
        element: <VerifikatorPesertaKepemimpinanSmbjmPage />,
      },
    ],
  },
  {
    element: <VerifikatorRaportLayout />,
    children: [
      {
        path: "/verifikator/raport/dashboard",
        element: <DashboardVerifikatorRaportPage />,
      },
      {
        path: "/verifikator/raport/verifikasi-nilai-raport-smbjm",
        element: <VerifikatorDataNilaiRaportSmbjmPage />,
      },
      {
        path: "/verifikator/raport/verifikasi-raport-peserta",
        element: <VerifikasiRaportPesertaPage />,
      },
      {
        path: "/verifikator/raport/verifikasi-raport-peserta/view",
        element: <VerifikasiRaportPesertaDetailPage />,
      },
    ],
  },
  {
    element: <VerifikatorSklLayout />,
    children: [
      {
        path: "/verifikator/skl/dashboard",
        element: <DashboardVerifikatorSklPage />,
      },
      {
        path: "/verifikator/skl/verifikasi-skl-peserta",
        element: <VerifikasiSklPesertaPage />,
      },
      {
        path: "/verifikator/skl/verifikasi-skl-peserta/view",
        element: <VerifikasiSklDetailPage />,
      },
    ],
  },
  {
    element: <LoketmanLayout />,
    children: [
      {
        element: <LoketmanPage />,
        path: "/loket",
      },
    ],
  },
  {
    element: <OperatorPascaLayout />,
    children: [
      {
        element: <DashboardOperatorPascaPage />,
        path: "/operator-pasca/dashboard",
      },
      {
        element: <DataPendaftaranPascaPage />,
        path: "/operator-pasca/data-pendaftaran",
      },
      {
        element: <DataLoaPage />,
        path: "/operator-pasca/data-loa",
      },
      {
        element: <DataNilaiPage />,
        path: "/operator-pasca/data-nilai",
      },
      {
        element: <UsersElearningPage />,
        path: "/operator-pasca/users-elearning",
      },
      {
        element: <GroupsElearningPage />,
        path: "/operator-pasca/groups-elearning",
      },
      {
        element: <NilaiElearningPage />,
        path: "/operator-pasca/nilai-elearning",
      },
      {
        element: <MasterParentKomponenPenilaianPage />,
        path: "/operator-pasca/master/parent-komponen-penilaian",
      },
      {
        element: <MasterKomponenPenilaianPage />,
        path: "/operator-pasca/master/komponen-penilaian",
      },
      {
        element: <MasterBobotKomponenPenilaianPage />,
        path: "/operator-pasca/master/bobot-komponen-penilaian",
      },
      {
        element: <MasterBobotKomponenKaryatulisPage />,
        path: "/operator-pasca/master/bobot-komponen-karyatulis",
      },
      {
        element: <SettingVerifikatorPascaPage />,
        path: "/operator-pasca/setting/verifikator",
      },
      {
        element: <SettingVerifikatorPascaDetailPage />,
        path: "/operator-pasca/setting/verifikator/detail",
      },
    ],
  },
  {
    element: <OperatorStudentExchangeLayout />,
    children: [
      {
        element: <DataPendaftaranStudentExchangePage />,
        path: "/operator-studentexchange/data-pendaftaran",
      },
      {
        element: <SettingPeriodeOperatorStudentExchangePage />,
        path: "/operator-studentexchange/setting/periode",
      },
    ],
  },
  {
    element: <OperatorInternasionalLayout />,
    children: [
      {
        element: <DashboardOperatorInternasionalPage />,
        path: "/operator-internasional/dashboard",
      },
      {
        element: <DataPendaftaranInternasionalPage />,
        path: "/operator-internasional/data-pendaftaran",
      },
    ],
  },
  {
    element: <VerifikatorPascaLayout />,
    children: [
      {
        element: <VerifikatorPascaPenilaianPage />,
        path: "/verifikator-pasca/penilaian",
      },
      {
        element: <VerifikatorPascaDataNilaiPage />,
        path: "/verifikator-pasca/data-nilai",
      },
    ],
  },
  {
    element: <PanitiaSmbjmLayout />,
    children: [
      { element: <PanitiaSmbjmPage />, path: "/panitia-smbjm" },
      {
        element: <RuangCbtDetailPage />,
        path: "/panitia-smbjm/ruang-cbt-detail",
      },
      {
        element: <AlbumPesertaPage />,
        path: "/panitia-smbjm/album-peserta",
      },
    ],
  },
  {
    element: <AkademikLayout />,
    children: [
      {
        path: "/akademik/dashboard",
        element: <DashboardAkademikPage />,
      },
      {
        path: "/akademik/data-pendaftaran",
        element: <DataPendaftaranAkademikPage />,
      },
    ],
  },
  {
    element: <WawancaraTalentscoutingLayout />,
    children: [
      {
        path: "/wawancara-talentscouting/data-pendaftaran",
        element: <DataPendaftaranPesertaTalentscoutingPage />,
      },
    ],
  },
  {
    path: "/global/dashboard",
    element: <GlobalDashboardPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default function AppRouter() {
  const STORAGE_KEY_PRIMARY = "theme-primary-color";
  const STORAGE_KEY_SECONDARY = "theme-secondary-color"; // Tambahan Secondary
  const STORAGE_KEY_SIDEBAR = "theme-sidebar-color";

  const DEFAULT_PRIMARY = "#0040FF";
  const DEFAULT_SECONDARY = "#F1F5F9b"; // Slate-500 sebagai default Secondary
  const DEFAULT_SIDEBAR = "#ffffff";

  const [primaryColor, setPrimaryColor] = useState(DEFAULT_PRIMARY);
  const [secondaryColor, setSecondaryColor] = useState(DEFAULT_SECONDARY); // State Secondary
  const [sidebarColor, setSidebarColor] = useState(DEFAULT_SIDEBAR);
  const [isMounted, setIsMounted] = useState(false);

  // 1. LOAD FROM STORAGE
  useEffect(() => {
    setIsMounted(true);

    const savedPrimary = localStorage.getItem(STORAGE_KEY_PRIMARY);
    const savedSecondary = localStorage.getItem(STORAGE_KEY_SECONDARY);
    const savedSidebar = localStorage.getItem(STORAGE_KEY_SIDEBAR);

    if (savedPrimary) {
      setPrimaryColor(savedPrimary);
      setGlobalColorTheme(savedPrimary);
    } else {
      setGlobalColorTheme(DEFAULT_PRIMARY);
    }

    // Load Secondary
    if (savedSecondary) {
      setSecondaryColor(savedSecondary);
      setSecondaryTheme(savedSecondary);
    } else {
      setSecondaryTheme(DEFAULT_SECONDARY);
    }

    if (savedSidebar) {
      setSidebarColor(savedSidebar);
      setSidebarTheme(savedSidebar);
    } else {
      setSidebarTheme(DEFAULT_SIDEBAR);
    }
  }, []);

  // 2. SAVE & APPLY PRIMARY
  useEffect(() => {
    if (isMounted) {
      setGlobalColorTheme(primaryColor);
      localStorage.setItem(STORAGE_KEY_PRIMARY, primaryColor);
    }
  }, [primaryColor, isMounted]);

  // 3. SAVE & APPLY SECONDARY
  useEffect(() => {
    if (isMounted) {
      setSecondaryTheme(secondaryColor);
      localStorage.setItem(STORAGE_KEY_SECONDARY, secondaryColor);
    }
  }, [secondaryColor, isMounted]);

  // 4. SAVE & APPLY SIDEBAR
  useEffect(() => {
    if (isMounted) {
      setSidebarTheme(sidebarColor);
      localStorage.setItem(STORAGE_KEY_SIDEBAR, sidebarColor);
    }
  }, [sidebarColor, isMounted]);

  return <RouterProvider router={router} />;
}
